/* eslint-disable no-undef */
/**
 * site-scripts.js
 *
 * All general site scripts
 */

import Swiper from 'swiper/bundle';
import { groupEventListener } from './utils';



(function ($) {
	// Header Events

	const body = document.body;
	$(document).on('ready', function () {
		// Replace any href="#" links with href="javascript:void(0)"
		if (document.body.contains(document.querySelector('[href="#"]'))) {
			const emptyHrefs = Array.prototype.slice.call(
				document.querySelectorAll('[href="#"]')
			);
			emptyHrefs.forEach((link) => {
				link.href = 'javascript:void(0)';
			});
		}

		// Add .js-subnav-toggle class to any mobile nav items with children
		if (
			document.body.contains(
				document.querySelector('.menu-item-has-children')
			)
		) {
			const topLevelItems = Array.prototype.slice.call(
				document.querySelectorAll('.menu-item-has-children')
			);
			topLevelItems.forEach((item) => {
				item.classList.add('js-subnav-toggle');
			});
		}

		// If .sub-menu exists
		if (document.body.contains(document.querySelector('.sub-menu'))) {
			groupEventListener(
				'click',
				document.querySelectorAll('.js-subnav-toggle'),
				toggleSubMenu
			);
		}

		if (document.querySelector('.js-play')) {
			document
				.querySelector('.js-play')
				.addEventListener('click', toggleVideo);
			document
				.querySelector('.btn--play')
				.addEventListener('click', togglePlay);
		}

		if (
			document.body.contains(document.querySelector('.js-modal')) ||
			document.body.classList.contains('search')
		) {
			groupEventListener(
				'click',
				document.querySelectorAll('.js-modal'),
				toggleModal
			);
			groupEventListener(
				'click',
				document.querySelectorAll('.js-close-modal'),
				closeModal
			);
		}
	});

	if (document.body.contains(document.querySelector('.hamburger'))) {
		document
			.querySelector('.hamburger')
			.addEventListener('click', openMobileNav);
		document
			.querySelector('.header--mobile .btn--close')
			.addEventListener('click', closeMobileNav);
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('click', toggleAriaExpanded);
			});
	} else {
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('mouseover', toggleAriaExpanded);
			});
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('mouseout', toggleAriaExpanded);
			});
	}

	// Expand Module

	groupEventListener(
		'click',
		document.querySelectorAll('.js-expand'),
		expandModule
	);
	groupEventListener(
		'click',
		document.querySelectorAll('.js-toggle-list'),
		toggleList
	);

	function openMobileNav() {
		document.querySelector('.header--mobile').classList.add('-is-open');
		document.querySelector('.btn--close').focus();
		document.querySelector('body').classList.add('-hide-page-overflow');
	}

	function closeMobileNav() {
		document.querySelector('.header--mobile').classList.remove('-is-open');
		document.querySelector('body').classList.remove('-hide-page-overflow');
	}

	function toggleSubMenu() {
		this.classList.toggle('active');
	}

	function toggleAriaExpanded() {
		const expanded =
			this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
		this.setAttribute('aria-expanded', expanded);
	}

	function toggleModal() {
		const modalType = this.dataset.modal;
		document
			.querySelector('[data-modal-window="'.concat(modalType, '"]'))
			.classList.add('active');
		document.body.classList.add('-hide-page-overflow');
	}

	function closeModal() {
		const modalType = this.dataset.modalClose;
		document
			.querySelector('[data-modal-window="'.concat(modalType, '"]'))
			.classList.remove('active');
		document.body.classList.remove('-hide-page-overflow');
	}

	function addModalCloseEvent(modal) {
		window.onclick = function (event) {
			if (event.target === modal) {
				modal.classList.remove('active');
				document.body.classList.remove('-hide-page-overflow');
			}
		};
	}



	if ($('.page-nav-item-link')) {
		$('.page-nav-item-link').each(function () {
			$(this).click(function (e) {
				const anchor = e.currentTarget.dataset.anchor;
				document.getElementById(`${anchor}`).scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			});
		});
	}

	// Expandable Modules:
	// 1. Features Module

	function expandModule() {
		const openToggle = document.querySelector('.-is-expanded');
		if (openToggle && openToggle !== this) {
			openToggle.classList.remove('-is-expanded');
		}
		this.classList.toggle('-is-expanded');
	}

	if (document.body.classList.contains('page-template-page-membership')) {
		document.addEventListener(
			'click',
			function (event) {
				if (event.target.closest('.js-expand')) return;
				document
					.querySelector('.-is-expanded')
					.classList.remove('-is-expanded');
			},
			false
		);
	}

	// Toggle List

	function toggleList() {
		document.querySelector('.list-expand').classList.toggle('-is-expanded');
	} // Animations

	function typeEffect(element, speed) {
		const text = element.innerHTML;
		element.innerHTML = '';
		let i = 0;
		const timer = setInterval(function () {
			if (i < text.length) {
				element.append(text.charAt(i));
				i++;
			} else {
				clearInterval(timer);
			}
		}, speed);
	}

	// Mailchimp Newsletter Form
	$('#mc_mv_EMAIL').attr('placeholder', $('label.mc_header_email').html());
	$('label.mc_header_email').hide();
	$('.mc_email_format').parent().hide();


	function insertByline() {
		const toInsert =
			'<br>Made by <a href="https://sixtyfivedesign.com/" target="_blank">Sixty Five Design</a>.';
		$('.footer-text .copyright').after(toInsert);
	}
	insertByline();
})(jQuery);
